<template>
  <div ref="container" class="device-monitor_menu">
    <!-- <div class="toggle-collapse">
      <span>{{ '任务列表' | translateTo(i18nPath) }}</span>
      <div class="toggle-icon" @click="changeCollapse">
        <em :class="!toggle ? 'el-icon-s-unfold' : 'el-icon-s-fold'"></em>
      </div>
    </div> -->
    <div ref="content" class="content">
      <el-input
        :placeholder="'请输入内容' | translateTo(i18nPath)"
        size="medium"
        clearable
        v-model="search"
        class="search-input"
      >
        <el-button slot="append" icon="el-icon-search"></el-button>
      </el-input>
      <Menu
        :menu="menu"
        :unique-opened="true"
        :default-openeds="defaultOpeneds"
        :default-active="defaultActive"
        @node-click="handleNodeClick"
        @select="handleSelect"
        @open="handleOpen"
        @itemContextmenu="handleContextmenu"
      />
    </div>
  </div>
</template>

<script>
import Menu from './Menu';
import { mapState } from 'vuex';
import { isEmpty } from '@/utils/is';
import { toLowerCase } from '@/utils/transform';
import anime from 'animejs';

import { extDeviceParentIds } from '@/utils/deviceUtils';

import { deviceContextMenu } from '../../utils/contextMenu';

export default {
  components: { Menu },
  data() {
    return {
      i18nPath: 'monitor.menu',
      toggle: false,
      search: '',
      tl: null
    };
  },
  computed: {
    ...mapState('socket', ['deviceTree', 'devicesSourseMap', 'deviceIdMap']),
    ...mapState('device', ['monitorMenuActive']),
    menu() {
      if (isEmpty(this.search)) {
        return this.deviceTree;
      } else {
        return this.devicesSourseMap.filter(e => {
          if (isEmpty(e.name)) return false;
          return toLowerCase(e.name).indexOf(toLowerCase(this.search)) !== -1;
        });
      }
    },
    defaultOpeneds() {
      return extDeviceParentIds(this.monitorMenuActive, this.deviceIdMap);
    },
    defaultActive() {
      const t = this.monitorMenuActive;
      if (isEmpty(t) || isEmpty(t.id)) return '';
      return t.id;
    }
  },
  methods: {
    handleContextmenu({ event, data }) {
      deviceContextMenu.call(this, event, data);
    },
    changeCollapse() {
      this.toggle = !this.toggle;
      this.toggleContent(this.toggle);
    },
    toggleContent(flag) {
      const content = this.$refs.content;
      const container = this.$refs.container;
      const tl = anime.timeline({
        easing: 'easeOutExpo'
      });
      if (flag) {
        tl.add({
          targets: content,
          translateY: '-100%',
          duration: 500
        });
        tl.finished.then(() => {
          anime.set(container, { height: '40px' });
        });
      } else {
        anime.set(container, {
          height: 'calc(80% - 40px)'
        });
        tl.add({
          targets: content,
          translateY: 0,
          duration: 500
        });
      }
    },
    handleOpen(id) {
      const node = this.deviceIdMap[id];
      this.$emit('open', node);
    },
    handleSelect(id) {
      const node = this.deviceIdMap[id];
      this.$emit('select', node);
    },
    handleNodeClick(id) {
      const node = this.deviceIdMap[id];
      this.$emit('node-click', node);
    }
  }
};
</script>

<style lang="scss">
.device-monitor_menu {
  position: absolute;
  left: 15px;
  top: 75px;
  z-index: 9;
  opacity: 0.9;

  width: 400px;
  height: calc(80% - 40px);
  overflow: hidden;

  user-select: none;
  pointer-events: none;

  .toggle-collapse {
    display: flex;
    align-items: center;
    user-select: none;

    font-size: 22px;

    .toggle-icon {
      color: #f1ff52;
      font-size: 26px;

      pointer-events: auto;
      cursor: pointer;
    }
  }

  .content {
    position: inherit;
    left: 0;
    bottom: 0;

    width: 100%;
    height: 100%;
    padding: 0;

    background: var(--monitor-menu-content-bg, #0c1620);
    border-radius: 6px;
    overflow: hidden;

    pointer-events: auto;

    .search-input {
      margin-bottom: 10px;
    }

    .menu-container {
      height: calc(100% - 50px);
    }
  }
}
</style>
